"use strict";

let navButton = document.querySelector(".title--menu");
navButton.addEventListener("click", toggleNavigation);


function toggleNavigation() {
    if (document.body.hasAttribute("data-menu")) {
        document.body.removeAttribute("data-menu");
        navButton.innerHTML = "Témoignages";
    } else {
        document.body.setAttribute("data-menu", true);
        navButton.innerHTML = "Fermer";
    }
}


const pictureTem = document.querySelector(".img--images");
const titleTem = document.querySelector(".slide-up-text");
const imgTem = document.querySelector(".img--anim");



const ARRAY_lili = [
    [
        "J’étais assise à l’arrière d’un tram vide, quand cet homme s’est installé en face de moi. Je ne vous cache pas que lorsque je l’ai vu s’installer j’étais un peu saoulée, car je me disais que sur toutes les places qu’il y avait, c’était en face de moi qu’il avait décidé de s’asseoir… Bref",
        "En voyant qu’il me regardait, j’ai vite décidé de sortir mon gsm pour mettre un peu de musique et surtout éviter ses appels de phares. J’ai mis une musique apaisante, puis j’ai très vite tourné la tête pour me concentrer sur le paysage qui m’entourait",
        "Hahaha ! Plus facile à dire qu’à faire! Malheureusement dans la vraie vie, les choses ne se sont pas passées comme ça…" + " <br /> " + " <br /> " + "Ce jour-là, j’avais un rendez-vous très important avec ma prof de morale. Ma classe et moi étions attendus au palais de justice pour participer à une audience. C’était une grande première pour moi, c’est pourquoi je me posais énormément de questions sur le déroulement de cette journée",
        "J’étais concentrée dans mes pensées, pourtant, j’avais l’impression de voir quelque chose bouger en direction de cet homme. Je n’ai pas regardé tout de suite, car je me disais qu’il essayait sûrement d’attirer mon attention. Alors j’ai fermé les yeux… ",
        "Ce mec était clairement en train de se branler!" + " <br /> " + " <br /> " + " Toi aussi t’es choqué ? Après 5 sec, j’ai ouvert les yeux en direction de cet homme. Ce que j’ai vu m’a pétrifié, je n’osais plus bouger. Il était toujours là, assit en face de moi, en train de se branler en me regardant." + " <br /> " + " <br /> " + "Je me souviens m’être dit, heureusement que je ne suis plus vierge, parce que le zizi de cet homme aurait été le premier sexe que j’ai vu de ma vie",
        "Sur le coup, j’ai juste repris mon gsm et fais semblant d’envoyer un message,  seulement, mes mains tremblaient, j’avais très peur. Alors je me suis levé d’un bond et j’ai été m’installer à l’avant à côté du chauffeur",
    ],
    [
        ["Ouais, les gars comme ça c’est relou!", "Heureusement, non."],
        ["J’aurais sorti un sabre laser !", "Changé de place."],
        ["Passer à la suite.", ""],
        ["Il se branlait.", "Il me faisait signe."],
        ["Passer à la suite.", ""],
        ["oui", ""],
    ],

    [1, 2, 3, 4, 5, 6],

    [
        "Ça t’est déjà arrivé ?",
        "Qu’aurais-tu fais ?",
        "",
        "Que faisait-il selon toi ?",
        "",
        "Choqué par ce genre d'attitude ?",
    ],
];

const ARRAY_aya = [
    [
        "Il était relativement tôt, quand je me suis retrouvée dans ce métro de la ligne 5, bondé de monde. C’est en arrivant à me faufiler entre deux, trois personnes, que j’ai réussi à me trouver une petite place. J’en ai profité pour sortir mon téléphone et regarder mon actu Instagram",
        "Seulement, un sentiment étrange m’habitait. J’avais le sentiment que quelqu’un m’observait sans en être sûre pour autant… C’est pourquoi, j’ai décidé de lever la tête, histoire de confirmer ce sentiment",
        "C’est à ce moment-là que je l’ai vu. Il se trouvait en face de moi et m’observait. J’étais très mal à l’aise, car il continuait à me fixer, mais cette fois, dans les yeux. Tout ce que je déteste",
        "Pour ne pas me laisser faire, j’ai décidé de le fixer et de sortir mon regard le plus noir en fronçant les sourcils pour qu’il comprenne que je voulais qu’il arrête. Mais j’ai très vite compris que cette action lui procurait l’effet inverse, à savoir qu’il jouait de ça, ça le faisait rire de voir qu’il me m’était mal à l’aise.",
        "La honte et la colère se sont rapidement emparées de moi, c’est pourquoi, j’ai décidé de baisser les yeux et de reprendre mon gsm… Je me demandais si les gens autour de moi voyaient à quel point cet homme me dérangeait. Étant donné que personne ne réagissait, je me suis rendu compte que j’étais seule dans cette situation.",
        "J’ai repris mon gsm pour continuer à regarder mon actu, mais j’avais l’impression de ne voir que lui. Puis je sentais bien qu’il continuait à me regarder, seulement, je n’osais pas lever la tête par peur qu’il pense qu’il me plaise ou que les gens qui assistaient à la scène pense que j’aguichais cet homme" + " <br /> " + " <br /> " + "C’est, seulement, après 15 min à fixer le sol que j’ai décidé de lever la tête." + " <br /> " + " <br /> " + "Il n’était plus là…",
    ],
    [
        ["Passer à la suite.", ""],
        ["Ouais, ça fait trop peur !", "Oufti, Non."],
        ["J’aurais pris mon gsm pour faire genre.", "Je l’aurais fixé jusqu’à ce qu’il arrête."],
        ["Passer à la suite.", ""],
        ["Oui, on se sent bien seule.", "Non j’ignore ce que ça fait"],
        ["oui", ""],
    ],

    [1, 2, 3, 4, 5, 6],

    [
        "",
        "Ça t’est déjà arrivé ? ",
        "Qu’aurais-tu fais ? ",
        "",
        "Tu as déjà vécu ça ? ",
        "Choqué par ce genre d'attitude ?",
    ],
];

const ARRAY_lou = [
    [
        "J’étais assise dans ce métro de la ligne 2. En face de moi, se trouvaient un homme et une femme tous deux concentrés sur leurs téléphones. C’est à l’arrêt Madou que cet homme de facilement 2 mètres est venu s’installer à côté de moi.",
        "Je me suis très vite sentie extrêmement mal à l’aise, car il était assis et pourtant, il gardait les mains dans les poches de sa veste, ce qui a provoqué chez moi un profond sentiment d’inconfort, car il prenait deux places à lui seul et empiétait sur mon espace vital.",
        "J’ai levé les yeux pour voir si les gens autour de moi voyaient ce qui était en train de se passer, seulement, je n’ai eu la chance de croiser aucun regard. Alors je me suis dit que j’exagérais peut-être.",
        "Malheureusement, ce n’est pas ce que j’ai fait…" + " <br /> " + " <br /> " + "Plus le métro avançait et plus les coudes de cet homme s’approchaient de mon corps. Étant donné qu’il était grand, il a fallu peu d’arrêts, avant qu’il puisse arriver à hauteur de ma poitrine. Une fois le but atteint, il a commencé à bouger ses coudes…",
        "On pouvait voir ma poitrine bouger… Mon cœur battait à mille à l’heure et pourtant, je n’osais rien dire, ni faire à part subir cette situation. J’avais très peur de me faire agresser, car je trouvais cet homme très impressionnant de par sa taille et sa carrure.",
        "C’est au bout de 4 arrêts, les 4 arrêts de métro les plus longs de ma vie que j’ai décidé de sortir du métro en courant. J’ai attendu que le métro émette un signal sonore pour avertir les passagers de la fermeture des portes pour me faufiler entre elles et sortir sans me retourner." + " <br /> " + " <br /> " + "C’est après 15 min à fixer le sol que j’ai décidé de lever la tête." + " <br /> " + " <br /> " + "Le métro n’était plus là…",
    ],
    [
        ["Passer à la suite.", ""],
        ["Ouais, c’est insupportable !", "Non."],
        ["Je lui aurais demandé de reculer !", "J’aurais changé de place."],
        ["Passer à la suite.", ""],
        ["Passer à la suite.", ""],
        ["oui", ""],
    ],

    [1, 2, 3, 4, 5, 6],

    [
        "",
        "Ça t’est déjà arrivé ? ",
        "Qu’aurais-tu fais ? ",
        "",
        "",
        "Choqué par ce genre d'attitude ?",
    ],
];

if (titleTem !== null) {
    function enterImg() {
        titleTem.style.opacity = 0;
        imgTem.style.transform = "scale(1.2)";
        console.log("entrer");
    }

    function leaveImg() {
        titleTem.style.opacity = 1;
        imgTem.style.transform = "scale(1)";
        console.log("sortie");
    }

    pictureTem.addEventListener("mouseenter", enterImg)
    pictureTem.addEventListener("mouseleave", leaveImg)
}

function updateText(ARRAY) {
    //initialisation de la variable gerant l'avancement du texte
    let state = 0;
    //#region initialisation de la situation de départ
    µ("#text").text(ARRAY[0][state]);
    document.querySelector("#btn01").innerText = ARRAY[1][state][0];
    document.querySelector("#btn02").innerText = ARRAY[1][state][1];
    //document.querySelector("#title--quatre").innerText= ;
    µ('.title--quatre').text(ARRAY[3][state]);
    if (document.querySelector('#btn02').innerHTML == "") {
        µ('#btn02').css('display', 'none');
    } else {
        µ('#btn02').css('display', 'block');
    }
    state++;
    // alert(document.querySelector(`#title--quatre`)


    //#endregion
    //#region déclaration du listenener sur les boutons de changement de situation/de texte
    µ(".btns").click(() => {
        if (state < ARRAY[0].length) {
            µ("#animText").addClass("animateText");
            µ(".btns").addClass("animateBtns");
            setTimeout(() => {
                µ("#animText").removeClass("animateText");
                µ(".btns").removeClass("animateBtns");
                µ("#text").html(ARRAY[0][state]);
                if (state < ARRAY[0].length - 1) {
                    document.querySelector("#btn01").innerText = ARRAY[1][state][0];
                } else {
                    document.querySelector("#btn01").innerHTML = `<a class="link" href="solutions.html"> ${ARRAY[1][state][0]} </a>`;
                }
                document.querySelector("#btn02").innerText = ARRAY[1][state][1];
                document.querySelector('.title--trois').innerText = `${ARRAY[2][state]} | ${ARRAY[2].length}`;
                //console.log(document.querySelector(`title--quatre`))
                //document.querySelector(`#title--quatre`).innerHTML = ARRAY[3][state];
                µ('.title--quatre').text(ARRAY[3][state])
                // const titleQuatre = document.querySelector("#btn02");
                if (document.querySelector('#btn02').innerHTML == "") {
                    µ('#btn02').css('display', 'none');
                } else {
                    µ('#btn02').css('display', 'block');
                }
                //   console.log(titleQuatre);
                //   console.log(titleQuatre.innerHTML);
                state++;
            }, 1100); //mettre le temps de l'animation+10% en ms
        }
    });
}
//#endregion


const body = document.querySelector('body')
if (body.dataset.pageid == 1) updateText(ARRAY_lili);

if (body.dataset.pageid == 2) updateText(ARRAY_aya);

if (body.dataset.pageid == 3) updateText(ARRAY_lou);






